import { useIsomorphicLayoutEffect } from '@dnd-kit/utilities'
import { useState } from 'react'

// This is to check if a text field is truncated
// It is used to show a tooltip only when the text is truncated
export const useCheckTruncated = (ref: React.RefObject<HTMLElement>) => {
  const [isTruncated, setIsTruncated] = useState<boolean>(false)

  useIsomorphicLayoutEffect(() => {
    if (!ref.current) return
    const { scrollWidth, clientWidth } = ref.current
    setIsTruncated(scrollWidth > clientWidth)
  }, [ref])

  return isTruncated
}
